import React, { useState } from 'react';
import { Row, Col, Form,  Button, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Input from '../../../../ui/Input';
import Collapse, { Panel } from '../../../../ui/Collapse';

interface propsTypes {
  dataList: void | any,
  currentForm: void | any,
}
interface dataType {
  name: string
}
const Option = Select.Option;
const unitMeasure = ['Watt(s)', 'Kilowatt(s)', 'Gallon(s)', 'Litre(s)', 'CubicFeet', 'CubicMeter(s)']
const powerType = ['DieselForEmergency', 'Electric', 'Gas', 'Oil', 'PetrolForEmergency', 'Solar', 'Other']
const EnergyUsageEdit = (props: propsTypes) => {
  const data = props.dataList?.environmentalimpact?.energyusage?.energyusage || [];
  const [panelList, setPanelList] = useState(data);
  const [refreshCount, setRefreshCount] = useState(0);
  const addClick = () => {
    const newpanelList = panelList.concat([{ amount: ' ', uom: ' ', powertype: ' ' }]);
    setPanelList(newpanelList);
    setRefreshCount(refreshCount + 1);
  }
  const closeClick = (index: number) => {
    const validData = panelList.filter((item: any, i: number) => {
      return item.amount || item.uom || item.powertype
    })
    if (validData.length > 1) {
      const _panelList = JSON.parse(JSON.stringify(panelList))
      _panelList[index].amount = null;
      _panelList[index].uom = null;
      _panelList[index].powertype = null;
      setPanelList(_panelList)
    }
    props.currentForm.setFieldsValue({
      [`firstIptName-${index}`]: '',
      [`secounIptName-${index}`]: '',
      [`thirdIptName-${index}`]: '',
    })
  }

  return (
    <>
      <Collapse
        defaultActiveKey={panelList.map((_: object, i : number) => i)}
        multiCollapseButton key={refreshCount}
      >
        <>
          {
            panelList.map((item: any, i: any) => (
              <React.Fragment key={i}>
                {
                  item.amount || item.uom || item.powertype
                    ? <Panel
                      collapsible="header"
                      key={i}
                      header={`Energy Usage ${i + 1}`}
                      style={{ marginBottom: '20px' }}
                      deleteButton={{
                        action: () => closeClick(i),
                        title: `Are you sure you want to delete Energy Usage ${i + 1}?`,
                      }}
                    >
                      <Row gutter={24}>
                        <Col span={6}>
                          <Form.Item name={`firstIptName-${i}`} label='Energy Usage Amount'
                            rules={[
                              { pattern: /^\d*?$/, message: "This field should be a number." }
                            ]}>
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            extra={<span className="blue-font">If Power Type is Electric, Gas, Oil, please choose Kilowatt(s) which will be noted as Kilowatt(s)/hour; If Power Type is DieselForEmergency, PetrolForEmergency, please choose Litre(s)</span>}
                            name={`secounIptName-${i}`}
                            label='Unit of Measure'>
                            <Select allowClear showSearch>
                              {
                                unitMeasure.map(item => <Option key={item} value={item}>{item}</Option>)
                              }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item name={`thirdIptName-${i}`} label='Power Type'>
                            <Select allowClear showSearch>
                              {
                                powerType.map(item => <Option key={item} value={item}>{item}</Option>)
                              }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Panel>
                    : null
                }
              </React.Fragment>
            ))
          }
        </>
      </Collapse>
      <Button
        type="link"
        onClick={() => (addClick())}
        icon={<PlusOutlined />}
        style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
      >
        {`Add Energy Usage ${panelList.length + 1}`}
      </Button>
    </>
  )
}


export default EnergyUsageEdit;
